import React from 'react';
import { useWorkplaceCertificatesQuery } from '../../../../../../graphql/graphql';
import styles from './ManagerCertificatesList.module.scss';
import Loading from '../../../../../../Components/Loading';
import ManagerCertificatesListItem from './ManagerCertificatesListItem';

interface Props {
	workplaceId: string;
}

const ManagerCertificatesList: React.FC<Props> = ({ workplaceId }) => {
	const { data, isLoading, refetch } = useWorkplaceCertificatesQuery({
		where: { workplaceId },
	});

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{data?.workplaceCertificates?.data?.map((workCert, index) => {
				if (workCert) {
					return (
						<ManagerCertificatesListItem
							item={workCert}
							key={index}
							onReload={refetch}
							workplaceId={workplaceId}
						/>
					);
				}
			})}
		</div>
	);
};

export default ManagerCertificatesList;
